export default __webpack_public_path__ + "static/image-mob-9dd957ee2e04a84e3041065d8a9b93bb.jpg";